import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { S3UploadService } from '../s3-upload.service';
import { ItemUploadDataJSON, S3UploadJSON } from '../s3-upload.interface';
import { first, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'zf-s3-upload-document',
  templateUrl: './s3-upload-document.component.html',
  styleUrls: ['./s3-upload-document.component.scss'],
})
export class S3UploadDocumentComponent implements OnInit, OnDestroy {
  @Input() urlPresigned!: string;
  @Input() bucket!: string;
  @Input() folder!: string;
  @Input() client!: string;
  @Input() sizeLimitMB!: number;
  @Input() removeAfterUploader!: boolean;
  @Input() multiple!: boolean;
  @Input() allowedExtensions =
    'pdf,docx,doc,zip,csv,xlsx,xls,png,jpg,jpeg,svg,zip';

  @Output() urlUploaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() urlUploadedError: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRemoved: EventEmitter<any> = new EventEmitter<any>();

  selectedFiles!: FileList;
  isUploaded = false;
  files: any[] = [];
  uploadedFiles: any[] = [];
  extension = 'generic';

  defaultImages: any = {
    generic: 'https://src-folder.s3.amazonaws.com/forms/generic.png',
    zip: 'https://src-folder.s3.amazonaws.com/forms/zip.png',
    xls: 'https://src-folder.s3.amazonaws.com/forms/xls.png',
    xlsx: 'https://src-folder.s3.amazonaws.com/forms/xls.png',
    csv: 'https://src-folder.s3.amazonaws.com/forms/csv.png',
    doc: 'https://src-folder.s3.amazonaws.com/forms/doc.png',
    docx: 'https://src-folder.s3.amazonaws.com/forms/doc.png',
    pdf: 'https://src-folder.s3.amazonaws.com/forms/pdf.png',
  };

  defaultIcons = {
    generic: 'fas fa-file',
    zip: 'fas fa-file-archive',
    xls: 'fas fa-file-excel',
    xlsx: 'fas fa-file-excel',
    csv: 'fas fa-file-csv',
    doc: 'fas fa-file-word',
    docx: 'fas fa-file-word',
    pdf: 'fas fa-file-pdf',
  };

  destroy$ = new Subject<boolean>();
  constructor(private uploadService: S3UploadService) {}

  ngOnInit(): void {}

  dropHandler(ev: any) {
    console.log('File(s) dropped');

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === 'file') {
          var file = ev.dataTransfer.items[i].getAsFile();
          console.log('... file[' + i + '].name = ' + file.name);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.files.length; i++) {
        console.log(
          '... file[' + i + '].name = ' + ev.dataTransfer.files[i].name
        );
      }
    }
  }

  dragOverHandler(ev: any) {
    console.log('File(s) in drop zone');

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
  }

  // upload(): void {
  //   this.isUploaded = true
  //   const file = this.selectedFiles.item(0)
  //
  //   const ext = file.name.split('.')[1]
  //
  //   if (ext === 'pdf' || ext === 'docx' || ext === 'doc' || ext === 'zip' || ext === 'csv' || ext === 'xlsx' || ext === 'xls') {
  //     const data: S3UploadJSON = {
  //       urlPresigned: this.urlPresigned,
  //       bucket: this.bucket,
  //       folder: this.folder,
  //       client: this.client
  //     }
  //
  //     const token = Math.floor(Math.random() * 100000000).toString()
  //
  //     this.uploadService.get(file, data, token)
  //       .pipe(first())
  //       .subscribe(result => {
  //         this.uploadService.put(result, file)
  //           .pipe(takeUntil(this.destroy$))
  //           .subscribe(() => {
  //             this.isUploaded = false
  //             this.urlUploaded.emit({
  //               status: 'success',
  //               url: this.uploadService.process(file, data, token).urlDownload,
  //               ext: ext
  //             })
  //           })
  //       })
  //   } else {
  //
  //     this.urlUploadedError.emit({
  //       status: 'error',
  //       message: 'The uploaded file is not a valid document'
  //     })
  //
  //   }
  // }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
  }

  selectFileMultiples(event: any): void {
    const files = event.target.files;
    for (const item of files) {
      const ext = item.name.split('.')[1];
      if (this.isValidDocument(ext)) {
        if (this.multiple) {
          this.files.push({
            token: Math.floor(Math.random() * 100000000).toString(),
            file: item,
            urlPresigned: this.urlPresigned,
            bucket: this.bucket,
            folder: this.folder,
            client: this.client,
            sizeLimitMB: this.sizeLimitMB,
          } as ItemUploadDataJSON);
        } else {
          this.files[0] = {
            token: Math.floor(Math.random() * 100000000).toString(),
            file: item,
            urlPresigned: this.urlPresigned,
            bucket: this.bucket,
            folder: this.folder,
            client: this.client,
            sizeLimitMB: this.sizeLimitMB,
          } as ItemUploadDataJSON;
        }
      } else {
        this.urlUploadedError.emit({
          status: 'error',
          message: `There are files with extensions that are not allowed`,
        });
      }
    }
  }

  isValidDocument(ext: string): boolean {
    if (this.allowedExtensions.split(',').includes(ext)) {
      this.extension = ext;
      return true;
    }

    return false;
  }

  onMultipleUploaded(event: any): void {
    if (!!this.removeAfterUploader) {
      for (let i = 0; i < this.files.length; i++) {
        const item = this.files[i];
        if (item.token === event.token) {
          this.files.splice(i, 1);
          break;
        }
      }
    }

    if (this.multiple) {
      const fileObject = this.files.find((item) => item.token === event.token);
      event.size = fileObject.file.size;
      event.formatSize = this.formatBytes(fileObject.file.size);
      event.ext = fileObject.file.name.split('.')[1];
      event.name = fileObject.file.name;
      event.isImage = this.uploadService.isImageFile(event.ext);
      this.uploadedFiles.push(event);
      if (this.uploadedFiles.length === this.files.length) {
        this.urlUploaded.emit(this.uploadedFiles);
      }
    } else {
      this.urlUploaded.emit(event);
    }
  }

  onRemovedFile($event: any): void {
    if (this.multiple) {
      const token = $event.token;
      const index = this.files
        .map((item) => {
          return item.token;
        })
        .indexOf(token);

      this.files.splice(index, 1);
      this.uploadedFiles.splice(index, 1);
      this.onRemoved.emit(this.uploadedFiles);
    } else {
      this.files = [];
      this.onRemoved.emit(true);
    }

    this.extension = 'generic';
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: any, decimals = 0) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
